// React Router v7 future flags (#419). Shared between the app's <Router> in index.js and
// any test that renders its own real router (MemoryRouter), so the two configurations
// cannot drift apart. v7_startTransition and v7_relativeSplatPath are both no-ops today:
// the app has exactly one splat route (App.js `<Route path='*' element={<NotFound />} />`),
// and components/pages/NotFound.js contains no Link, href or navigate, so relative splat
// resolution changes nothing there.
const ROUTER_FUTURE = {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
}

export default ROUTER_FUTURE
